import React from "react";
import { motion } from "framer-motion";
import { site } from "../content";

const footerVariants = {
  hidden: { opacity: 0.5 },
  visible: { opacity: 1, transition: { duration: 0.8, ease: "easeInOut" } },
};

const socialIconClasses = {
  linkedin: "fab fa-linkedin-in",
  instagram: "fab fa-instagram",
  facebook: "fab fa-facebook-f",
  youtube: "fab fa-youtube",
  twitter: "fab fa-twitter",
};

const socialLinks = Array.isArray(site.footer.social) ? site.footer.social : [];

function Footer() {
  return (
    <motion.footer
      initial="hidden"
      animate="visible"
      variants={footerVariants}
      className="bg-grey-dark"
    >
      <div className="type-label container mx-auto px-6 py-5 text-gray-400 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0 text-center sm:text-left">
        &copy; {new Date().getFullYear()} {site.footer.label}
        {socialLinks.length > 0 && (
          <div className="flex space-x-4 sm:space-x-8">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`social-icon ${link.icon}`}
                aria-label={link.label}
              >
                <i className={`${socialIconClasses[link.icon] || "fab fa-link"} sm:text-xl`} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        )}
      </div>
    </motion.footer>
  );
}

export default Footer;
